import { AlertService } from "./../../../services/alert/alert.service";
import { Component, OnInit, Input } from "@angular/core";
import { DomSanitizer } from '@angular/platform-browser';
import { LanguagesService } from "src/app/services/languagesService/languages.service";
import { ContentService } from "src/app/services/content/content.service";
import { ModalController } from "@ionic/angular";
@Component({
  selector: "app-privacy-policies",
  templateUrl: "./privacy-policies.page.html",
  styleUrls: ["./privacy-policies.page.scss"],
})
export class PrivacyPoliciesPage implements OnInit {
  data: any;
  file: any;
  @Input() isInnerPage = false;
  @Input() isModal = false;
  constructor(
    public languageService: LanguagesService,
    private contentService: ContentService,
    private alertService: AlertService,
    public modalController: ModalController,
    private sanitizer: DomSanitizer
  ) { }

  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  ngOnInit() {
    try {
      this.contentService
        .getTermsAndPolices("politicas")
        .then((data: any) => {
          if (data.length > 0) {
            this.data = data && data[0] ? data[0] : [];
            this.data.content = this.data.Content ? this.data.Content : this.data.content;
            if (this.data.content[0].Description) {
              this.data.content.push({
                type: "description",
                value: this.data.content[0].Description
              })
            }
            this.file = this.data.content;
          } else {
            if (this.isModal) {
              this.alertService.presentAlert(
                "No tienes Politicas asociadas "
              );
              this.back();
            }
          }
        })
        .catch((error) => {
          if (error.error.code == "NOT_FOUND") {
            this.back();
            this.alertService.presentAlert("No tienes Politicas asociadas ");
          }
        });
    } catch (error) {
      throw error;
    }
  }

  get getTextIUPrivacyPolicies() {
    return this.languageService?.textsIU?.page_privacy_policies;
  }

  back() {
    this.modalController.dismiss(null, null, "modal-privacy-policies");
  }
}
